import { useQueryClient } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import { queryKeys } from "@/queryKeys";
import { borrowerService } from "@/services/borrowers";

export function useDeleteBorrower() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => borrowerService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.borrowers() });
    },
  });
}
